import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import Link from "@material-ui/core/Link/Link";
import { useTranslation } from "react-i18next";

const APP_STORE_URL = "https://apps.apple.com/us/app/stackcare/id1471170266";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.stacklighting.stackcare";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      flexDirection: "column",
    },
    message: {
      textAlign: "center",
      maxWidth: "500px",
      padding: theme.spacing(2),
    },
  })
);

export function AipNotInstalledView() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Box className={classes.message}>
        <h3>
          {t("aip_not_installed_message_prefix")}
          <Link href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            iOS
          </Link>
          {t("aip_not_installed_message_or")}
          <Link href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            Android
          </Link>
          {t("aip_not_installed_message_suffix")}
        </h3>
      </Box>
    </Box>
  );
}
